import { fas } from '@awesome.me/kit-b4fd369ea4/icons'
import { TitleButton } from './TitleButton'
import { useDialog } from '../dialog/DialogContext'
import { ExportDialog } from '../dialog/ExportDialog';

export const ExportButton = ({ exportReq }) => {

  const { openDialog } = useDialog();

  const openExportDialog = () => {
    openDialog(ExportDialog, { data: exportReq });
  }

  return (
    <TitleButton
      dataTestId="export-button"
      icon={fas.faArrowCircleDown}
      toolTip="Export"
      onClick={openExportDialog}
    />
  )
}